import siteConfig from '../config/siteConfig.json';

export type PageType = 'home' | 'about' | 'services' | 'contact';

export interface PageConfig {
  title: string;
  description: string;
  keywords: string;
  structure: {
    hero?: {
      headlines: string[];
      subheadline: string;
    };
    services?: {
      title: string;
      items: Array<{
        title: string;
        description: string;
        icon: string;
      }>;
    };
    mission?: {
      title: string;
      content: string;
    };
    team?: {
      title: string;
      content: string;
    };
    email?: {
      title: string;
      items: string[];
    };
    linkedin?: {
      title: string;
      items: string[];
    };
    seo?: {
      title: string;
      items: string[];
    };
    form?: {
      title: string;
      fields: string[];
    };
    info?: {
      title: string;
      items: string[];
    };
  };
}

export function getPageConfig(page: PageType): PageConfig {
  try {
    return siteConfig.pages[page];
  } catch (error) {
    console.error(`Error loading page config for ${page}:`, error);
    return {
      title: '',
      description: '',
      keywords: '',
      structure: {}
    };
  }
}

export function getBrandColor(): string {
  try {
    return siteConfig.site.brandColor;
  } catch (error) {
    console.error('Error loading brand color:', error);
    return '#0B60B1';
  }
}

export function getSocialMediaLinks() {
  try {
    return siteConfig.site.socialMedia;
  } catch (error) {
    console.error('Error loading social media links:', error);
    return {
      linkedin: '',
      twitter: '',
      facebook: ''
    };
  }
}

export function getContactEmail(): string {
  try {
    return siteConfig.site.contactEmail;
  } catch (error) {
    console.error('Error loading contact email:', error);
    return 'contact@impactquill.com';
  }
}

export function getDomain(): string {
  try {
    return siteConfig.site.domain;
  } catch (error) {
    console.error('Error loading domain:', error);
    return 'impactquill.com';
  }
}

export function getSiteName(): string {
  try {
    return siteConfig.site.name;
  } catch (error) {
    console.error('Error loading site name:', error);
    return 'ImpactQuill';
  }
} 